// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function initialize(): void {
    if ($(".header__search--menu-mode").length === 0) {
        return;
    }

    $placeholder = $('.searchfield__greeting');

    if ($placeholder.length > 0) {
        startAnimation();
    }
}

// #endregion Exports

// #region Private functions

let $placeholder: JQuery<Node>;
let active:boolean;
let offset:number;
let text:string;

function startAnimation(): void {
    text = $placeholder.text();
    $placeholder.text("");
    active = true;
    offset = 0;

    setTimeout(typeLetter, 1000);

    $('.searchfield__input--large').keydown(stopAnimation);
}

function stopAnimation(): void {
    active = false;
    $placeholder.text(text);
}

function typeLetter() {
    if (!active) {
        return;
    }

    $placeholder.text(text.substr(0, offset));
    if (offset < text.length) {
        offset++;
        setTimeout(typeLetter, 50 + Math.random() * 100);
    } else {
        active = false;
    }
}

// #endregion Private functions
